var map = {
	"./1-1.png": "f3b1",
	"./2-1.png": "c3dd",
	"./3-1.png": "804b",
	"./4-1.png": "5a33",
	"./5-1.png": "74b0",
	"./6-1.png": "e03a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2b56";